module.exports = __webpack_public_path__ + "static/img/ent-64.2f5c3ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-64.jpg
// module id = dCa+
// module chunks = 52